import React, { FocusEventHandler } from 'react';

type CustomTextAreaControlProps = {
  label?: string;
  iconRight?: React.ReactElement;
  elementByLeftSideLabel?: React.ReactElement;
  showPwd?: boolean;
  customOnChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
  changePwdVisibility?: () => void;
  errorText?: string;
  showError?: boolean | string;
  onBlur?: FocusEventHandler<React.ChangeEvent<HTMLTextAreaElement>> | any | undefined;
};

type TextAreaControlProps = CustomTextAreaControlProps &
  React.TextareaHTMLAttributes<HTMLTextAreaElement>;

const TextAreaControl: React.FC<TextAreaControlProps> = ({
  customOnChange,
  elementByLeftSideLabel,
  label,
  errorText = '',
  onBlur,
  showError = false,
  ...textAreaProps
}) => {
  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (customOnChange) {
      customOnChange(event);
    }

    if (textAreaProps.onChange) {
      textAreaProps.onChange(event);
    }
  };

  return (
    <div className="c-input-control flex flex-col h-full">
      {label && (
        <label className="c-input-control__label flex justify-between pb-2.5 font-medium text-black dark:text-white">
          {label}
          {elementByLeftSideLabel}
        </label>
      )}
      <div className="c-input-control__input-wrapper relative h-full">
        <textarea
          {...textAreaProps}
          onChange={handleChange}
          className={`c-input-control__input w-full min-h-22 rounded-lg border border-stroke bg-transparent py-4 px-6 text-black outline-none focus-visible:shadow-none disabled:border-zinc-400 disabled:bg-zinc-300 disabled:text-stone-600 dark:border-form-strokedark dark:bg-form-input dark:text-white h-15 ${textAreaProps.className} ${
            showError
              ? 'focus:border-red dark:focus:border-red'
              : 'focus:border-primary dark:focus:border-primary'
          }`}
          onBlur={onBlur}
        />
      </div>
      <div className="flex min-h-6 items-center justify-start">
        {showError && <p className="text-sm text-red">{errorText}</p>}
      </div>
    </div>
  );
};

export default TextAreaControl;
